import { sampleUsers } from '../demo'

const state = {
  users: [],
  nextId: 4, // Khởi đầu sau demo data
}
const mutations = {
  SET_USERS(state, users) {
    state.users = users
  },
  ADD_USER(state, user) {
    user.id = state.nextId++
    state.users.push(user)
  },
  DELETE_USER(state, id) {
    state.users = state.users.filter(u => u.id !== id)
  },
  UPDATE_USER(state, updatedUser) {
    const index = state.users.findIndex(u => u.id === updatedUser.id)
    if (index !== -1) {
      state.users.splice(index, 1, updatedUser)
    }
  }
}
const actions = {
  initUsers({ commit }) {
    commit('SET_USERS', sampleUsers)
  },
  addUser({ commit }, user) {
    commit('ADD_USER', user)
  },
  deleteUser({ commit }, id) {
    commit('DELETE_USER', id)
  },
  updateUser({ commit }, user) {
    commit('UPDATE_USER', user)
  }
}

const getters = {
  users: state => state.users
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
